import { render } from "./StoriesView.vue?vue&type=template&id=2c7851a0&scoped=true"
import script from "./StoriesView.vue?vue&type=script&lang=js"
export * from "./StoriesView.vue?vue&type=script&lang=js"

import "./StoriesView.vue?vue&type=style&index=0&id=2c7851a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7851a0"]])

export default __exports__